import logo from './logo.svg';
import './App.css';
import Mode from './components/mode/mode';
import Id from './components/id/id';
import Light from './components/light/light';
import Handle from './components/handle/handle';
import Control from './components/control/control';
import Bag from './components/bag/bag';
import Battery from './components/battery/battery';
import QuickDisassembly from './components/quickDisassembly/quickDisassembly';
import Header from './components/header/header';
import { useState } from 'react';
let m2sText = window.detailText;
let productId = window.product_id;
let language = document.querySelector('meta[name="language"]').content;
document.getElementById('root').setAttribute('lang',language)

for (let item in m2sText) {
  m2sText[item] = formatText(m2sText[item]);
}

function formatText(text) {
  if (text.indexOf('{') < 0) {
    return text;
  } else {
    let rightBrackets = text.indexOf('{');
    let leftBrackets = text.indexOf('}') + 1;
    let oldText = text.slice(rightBrackets, leftBrackets);
    let newText = `<div class="m2s-primary-text">${text.slice(
      rightBrackets + 1,
      leftBrackets - 1,
    )}</div>`;

    return formatText(text.replace(oldText, newText));
  }
}
function App() {
  return (
    <>
      <Header m2sText={m2sText} productId={productId} language={language}></Header>
      {/* <Id></Id> */}
      <Light m2sText={m2sText}></Light>
      <QuickDisassembly m2sText={m2sText}></QuickDisassembly>
      <Handle m2sText={m2sText}></Handle>
      <Control m2sText={m2sText}></Control>
      <Mode m2sText={m2sText}></Mode>
      <Bag m2sText={m2sText}></Bag>
      <Battery m2sText={m2sText}></Battery>
    </>
  );
}

export default App;
